import debounce from 'debounce'
import { withRouter } from 'i18n/utils'
import { fetchEvents, setSearchEventInputValue, setEvent } from 'search/actions'
import { eventsSearchPendingSelector, eventsListSelector, searchEventInputSelector } from 'search/selectors'
import Modal from './Modal'

const ModalContainer = ({
    eventsSearchPending,
    events,
    searchEventInput,
    onClose,
    setSearchEventInputValue,
    fetchEvents,
    history,
    setEvent,
}) => {
    const [startDate, setStartDate] = React.useState()
    const [endDate, setEndDate] = React.useState()

    const changeInputValueHandler = (e, value) => {
        fetchEvents({ eventName: value, startDate, endDate })
        setSearchEventInputValue(value)
    }

    const changeInputValueHandlerDenounced = debounce(changeInputValueHandler, 500)

    const onEventChange = event => {
        if (event) {
            setEvent(event)
            history.push(`/booking/${event.locationId}/events`)
        }
    }

    const changeDateInputValueHandler = (start, end) => {
        fetchEvents({ startDate: start, endDate: end, eventName: searchEventInput })
        setStartDate(start)
        setEndDate(end)
    }

    return (
        <Modal
            onClose={onClose}
            events={events}
            loading={eventsSearchPending}
            initialValue={searchEventInput}
            onInputValueChange={changeInputValueHandlerDenounced}
            onDateInputChange={changeDateInputValueHandler}
            selectHandler={onEventChange}
        />
    )
}

const mapStateToProps = createStructuredSelector({
    eventsSearchPending: eventsSearchPendingSelector,
    events: eventsListSelector,
    searchEventInput: searchEventInputSelector,
})

const mapDispatchToProps = {
    fetchEvents,
    setSearchEventInputValue,
    setEvent,
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ModalContainer)
